

















































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import axios from "axios";
import { Notify } from "vant";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewSentence extends Vue {
  @Prop() show!: any;
  @Prop() words!: any;
  @Prop() wordLevel!: any;
  @Prop() CategoryId!: any;
  @Prop() LevelId!: any;

  copyWordLevel: any = "";
  WordLevelLength: number = 0;
  errors: any = [];

  new_level: any = {
    name: null,
    shortDescription: "",
    iconUrl: "",
    svgUrl: "",
  };

  checkRequired() {
    if (this.copyWordLevel.name) {
      return true;
    }
    this.errors = [];
    if (!this.copyWordLevel.name) {
      this.errors.push("name required.");
    }
  }
  UpdateWordLevel() {
    if (this.checkRequired()) {
      const RequestedData = {
        category_id: this.CategoryId,
        level: {
          id: this.copyWordLevel.id,
          name: this.copyWordLevel.name,
          shortDescription: this.copyWordLevel.shortDescription,
          svgUrl: this.copyWordLevel.svgUrl,
          iconUrl: this.copyWordLevel.iconUrl,
          exercise: this.copyWordLevel.exercise,
        },
      };
      const response = axios
        .post(
          "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/UpdateWordLevel",
          RequestedData
        )
        .then()
        .catch((error) => {
          Notify({ type: "danger", message: "Level is not updated" });
        });
      Notify({ type: "success", message: "Level updated" });
      this.wordLevel.name = this.copyWordLevel.name;
      this.show = false;
    }
  }

  showPopup() {
    this.show = true;
  }

  get WordLength() {
    return this.wordLevel.length + 2;
  }
  mounted() {
    const obj = this.wordLevel;
    this.copyWordLevel = Object.assign({}, obj);
    // console.log("copy ", copy); // { a: 1 }
  }
}
